// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 66380, offsets 86:485. Structure and names inferred from code, not screenshots.
import {
  loadArchivedChunk,
  archivedNamespace,
  hasOwn,
} from "../vendor/runtime.js";
const __bundleModule = {
  exports: {},
};
const __bundleExports = __bundleModule.exports;
var n = {
  "./doc-search-index.en.json": ["40727", [4876]],
  "./doc-search-index.zh.json": ["67258", [7671]],
};
function o(e) {
  if (!hasOwn(n, e))
    return Promise.resolve().then(function () {
      var t = Error("Cannot find module '" + e + "'");
      throw ((t.code = "MODULE_NOT_FOUND"), t);
    });
  var t = n[e],
    o = t[0];
  return loadArchivedChunk(t[1][0]).then(function () {
    return archivedNamespace(o, 19);
  });
}
((o.keys = function () {
  return Object.keys(n);
}),
  (o.id = 66380),
  (__bundleModule.exports = o));
export default __bundleModule.exports;
